export default "__VITE_ASSET__nGBPqtia__"